import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Fuel, CreditCard, Landmark, CalendarDays, Sparkles, LogOut, MapPin, Table2, Users2, Bot, Mail,
} from "lucide-react";

const nav = [
  { to: "/", label: "Genel Bakış", icon: LayoutDashboard, testid: "nav-overview-tab", end: true },
  { to: "/asistan", label: "Yapay Zeka Asistanı", icon: Bot, testid: "nav-ai-tab", module: "ai" },
  { to: "/yakit", label: "Aytemiz & Yakıt", icon: Fuel, testid: "nav-fuel-tab", module: "aytemiz" },
  { to: "/kartlar", label: "Kredi Kartları", icon: CreditCard, testid: "nav-cards-tab", module: "cards" },
  { to: "/krediler", label: "Krediler", icon: Landmark, testid: "nav-loans-tab", module: "loans" },
  { to: "/mailler", label: "E-postalar", icon: Mail, testid: "nav-mail-tab", module: "mail" },
  { to: "/aylik-plan", label: "Aylık Ödeme Planı", icon: Table2, testid: "nav-monthly-tab" },
  { to: "/takvim", label: "Ödeme Takvimi", icon: CalendarDays, testid: "nav-calendar-tab", module: "calendar" },
  { to: "/kullanicilar", label: "Kullanıcılar", icon: Users2, testid: "nav-users-tab", adminOnly: true },
  { to: "/yol-haritasi", label: "Yol Haritası", icon: Sparkles, testid: "nav-roadmap-tab" },
];

export default function Layout() {
  const { user, logout, can, isAdmin } = useAuth();
  const navigate = useNavigate();

  const visibleNav = nav.filter((n) => {
    if (n.adminOnly) return isAdmin;
    if (n.module) return can(n.module, "view");
    return true;
  });

  const doLogout = async () => {
    await logout();
    navigate("/giris");
  };

  return (
    <div className="min-h-screen flex bg-[#0A0D12] text-[#F8FAFC]">
      {/* Sidebar */}
      <aside className="hidden md:flex flex-col w-64 border-r border-[#253043] bg-[#0A0D12] fixed h-screen z-20">
        <div className="p-6 flex items-center gap-3 border-b border-[#253043]">
          <div className="w-10 h-10 rounded-xl bg-[#E65100] flex items-center justify-center shrink-0">
            <Fuel className="w-5 h-5 text-white" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold tracking-tight">İstasyonFinans</div>
            <div className="text-[11px] text-[#94A3B8]">Ödeme & Finans Takibi</div>
          </div>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {visibleNav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#E65100] text-white"
                    : "text-[#94A3B8] hover:text-white hover:bg-[#161D2A]"
                }`
              }
            >
              <n.icon className="w-[18px] h-[18px]" />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-[#253043]">
          <div className="px-3 py-2 mb-2 rounded-xl bg-[#111620]">
            <div className="flex items-center gap-2 text-[11px] text-[#94A3B8]">
              <MapPin className="w-3.5 h-3.5 text-[#F59E0B]" />
              İstasyon
            </div>
            <div className="text-sm font-medium mt-0.5 truncate">{user?.station || "-"}</div>
          </div>
          <button
            data-testid="logout-button"
            onClick={doLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-[#94A3B8] hover:text-[#EF4444] hover:bg-[#161D2A] transition-colors"
          >
            <LogOut className="w-[18px] h-[18px]" />
            Çıkış Yap
          </button>
        </div>
      </aside>

      {/* Mobile top nav */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-30 glass border-t border-[#253043] flex justify-around py-2">
        {visibleNav.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-2 py-1 rounded-lg text-[10px] ${
                isActive ? "text-[#E65100]" : "text-[#94A3B8]"
              }`
            }
          >
            <n.icon className="w-5 h-5" />
          </NavLink>
        ))}
      </div>

      <main className="flex-1 md:ml-64 min-w-0 pb-20 md:pb-0">
        <Outlet />
      </main>
    </div>
  );
}
